var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8088,
    cy: 32.8088,
    r: 31.5588,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_474)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0098 22.8096C29.5173 18.093 29.2393 15.4319 29.1758 14.8264C28.9372 12.5354 24.0842 12.7456 22.2703 13.5884C14.6047 17.1443 16.7875 27.247 19.5778 33.3479C24.877 43.3884 30.7545 49.2538 37.2087 50.941C42.2608 52.7055 48.799 51.4961 49.2177 45.3531C49.2743 44.5137 49.1885 43.8341 48.9603 43.3127C48.569 42.5305 45.7409 41.0603 40.4743 38.9056C39.4533 38.5473 38.2623 38.9544 36.8981 40.1268C36.6938 40.3051 36.4896 40.4598 36.2854 40.591C35.285 41.2269 34.7221 41.279 33.8006 40.5843C30.9914 38.4632 26.7338 30.9779 25.838 28.7323C25.6149 27.834 26.0148 27.1393 27.0341 26.6465C29.0076 25.7869 29.9995 24.5069 30.0098 22.8096Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.2346,
    height: 38.6815,
    fill: "white",
    transform: "translate(17 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.b008c57434b3a33ee541961d472510fb.svg";
export { ForwardRef as ReactComponent };